import React, { createContext, useEffect, useState } from "react";
import api from "../Utils/api";

export const uploadContext = createContext();

const isShallowEqual = (obj1, obj2) => {
  return Object.entries(obj1).reduce(
    (acc, [obj1Key, obj1Val]) => acc && obj1Val === obj2[obj1Key],
    true
  );
};

const createCheckJobs = (setJobs) => {
  const onGoingCount = (jobs) =>
    jobs && Array.isArray(jobs)
      ? jobs.filter((job) => job.status !== "DONE" && job.status !== "ERROR")
          .length
      : 0;
  let isChecking = false;
  const checkJobs = (jobsDoneCb, skipCheck = false) => {
    if (!skipCheck && isChecking) return;
    isChecking = true;
    api.getUserJobs().then((jobs) => {
      let oldJobs;
      setJobs((prevJobs) => {
        oldJobs = prevJobs;
        if (jobs.length !== prevJobs.length) return jobs;
        const matches = prevJobs.filter((job, index) =>
          isShallowEqual(job, jobs[index])
        );
        if (matches.length === prevJobs.length) return prevJobs;

        return jobs;
      });
      if (jobsDoneCb && oldJobs && onGoingCount(oldJobs) > 0 && onGoingCount(jobs) === 0) {
        jobsDoneCb();
      }
      if (onGoingCount(jobs) > 0) {
        setTimeout(() => {
          checkJobs(jobsDoneCb, true);
        }, 3000);
      } else {
        isChecking = false;
      }
    });
  };
  return checkJobs;
};
const createClearJobs = (setJobs) => () => {
  api.clearUserJobs().then(() => {
    setJobs((jobs) =>
      jobs.filter((job) => job.status !== "DONE" && job.status !== "ERROR")
    );
  });
};

export const UploadContextProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);
  const checkJobs = createCheckJobs(setJobs);
  const clearJobs = createClearJobs(setJobs);
  useEffect(() => {
    checkJobs();
    // eslint-disable-next-line
  }, []);
  return (
    <uploadContext.Provider
      value={{
        jobs,
        checkJobs,
        clearJobs,
      }}
    >
      {children}
    </uploadContext.Provider>
  );
};
